import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { APP_PREFIX } from '@/shared/constants/app-prefix.constant';
import { getDomainFromPathname } from '@/shared/lib/helpers/get-domain-from-pathname.helper';
import { useAppPrefix } from '@/shared/lib/hooks/use-app-prefix.hook';

const GlobalPrefixGuardComponent = () => {
	const { pathname, search } = useLocation();
	const navigate = useNavigate();
	const prefix = useAppPrefix();
	const lastPrefixRef = useRef<string>(undefined);

	useLayoutEffect(() => {
		const domain = getDomainFromPathname(pathname);

		if (domain) {
			lastPrefixRef.current = APP_PREFIX[domain];

			return;
		}

		// Keep the active domain for absolute navigations like navigate(AppRoutes.Dashboard)
		navigate(`${lastPrefixRef.current ?? prefix}${pathname}${search}`, { replace: true });
	}, [pathname, search, prefix, navigate]);

	return null;
};

export default GlobalPrefixGuardComponent;
